import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { H5 } from '../../themes/typography';

export default function CustomAccordion({
    accordtionTitle = 'Accordion Title',
    children = 'Accordion Content',
    expanded,
    onChange,
    darkMode,
    accordionNumber,
    accordionEmail
}) {
    return (
        <Accordion
            defaultExpanded={expanded}
            onChange={onChange}
            sx={{
                width: '100%',
                fontWeight: 600,
                background: darkMode ? 'rgba(0, 0, 0, 0.2)' : '#FFFFFF',
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                color: darkMode ? 'white' : 'inherit',
                borderRadius: '15px !important',
                boxShadow: 'none',
                textAlign: 'justify',
                '& .MuiAccordionSummary-root': {
                    minHeight: '56px'
                },
                '& .MuiAccordionSummary-expandIconWrapper': {
                    color: darkMode ? 'white' : 'gray'
                }
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
                sx={{
                    margin: '0px',
                    '& .MuiAccordionSummary-content.Mui-expanded': {
                        margin: '0px'
                    }
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        width: '90%',
                        justifyContent: 'space-between'
                    }}
                >
                    <H5 style={{ width: '260px' }}>{accordtionTitle}</H5>
                    <H5>{accordionNumber}</H5>
                    <H5>{accordionEmail}</H5>
                </div>
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    padding: '10px 20px 20px 20px'
                }}
            >
                {children}
            </AccordionDetails>
        </Accordion>
    );
}
